import { jsx as _jsx } from "react/jsx-runtime";
const LoadingScreen = () => {
    return (_jsx("div", { style: {
            backgroundColor: '#141B22',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1200,
        } }));
};
export default LoadingScreen;
//# sourceMappingURL=LoadingScreen.js.map